document.addEventListener("DOMContentLoaded", function () {
  const sectionId = document.querySelector(".product-page")?.id;
  if (sectionId) {
    window.initAccordionSection(sectionId);
  }

  const productData = window.productData;
  const productMedias = document.querySelectorAll(".main-media-wrapper");

  if (productMedias.length > 1) {
    const isMobile = window.innerWidth <= 999;
    const mediasSlider = document.querySelector(".main-media-container");
    const sliderBtns = document.querySelector(".slider-container .slider-btns");
    const prevArrow = document.querySelector(".slider-container .prev");
    const nextArrow = document.querySelector(".slider-container .next");
    const sliderBullets = document.querySelectorAll(".slider-bullet");
    const slider = document.querySelector(".gallery-main");
    const isRtl = !!slider?.closest('.rtl') || document.documentElement.dir === 'rtl';

    const mediaGap = 15;
    const DRAG_THRESHOLD = isMobile ? 50 : 150; // Minimum pixels to drag before changing slides
    const FADE_DELAY = 50; // Delay for fade effects in milliseconds
    const TRANSITION_DURATION = 300;
    let currentSlideIndex = 0;
    let mediaLength = productMedias.length;
    let timeout;

    let isTransitioning = false;
    let queuedNavigation = null;

    const updateArrow = (index) => {
      prevArrow.disabled = index === 0;
      nextArrow.disabled = index === mediaLength - 1;
    };
    updateArrow(currentSlideIndex);

    // Drag state variables
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let dragDistance = 0;
    let exceededThreshold = false;
    let direction = null; // 'left' or 'right'

    // Pause any playing videos when changing slides
    let sliderVideos = mediasSlider.querySelectorAll("video");
    const pauseAllVideos = () => {
      sliderVideos.forEach((video) => video.pause());
    };

    // Get the width of a single media item in percentage (cache to avoid forced reflow)
    let mediaWidthPercent;
    function updateMediaWidth() {
      // Use requestAnimationFrame to batch updates and avoid forced reflow
      requestAnimationFrame(() => {
        const sliderRect = mediasSlider.parentElement.getBoundingClientRect();
        const mediaRect = productMedias[0].getBoundingClientRect();
        mediaWidthPercent = (mediaRect.width / sliderRect.width) * 100;
      });
    }
    window.addEventListener("resize", updateMediaWidth, { passive: true });
    updateMediaWidth();

    // Calculate translateX value accounting for gaps (avoid forced reflow)
    function calculateTranslateX(index) {
      const sign = isRtl ? '' : '-';
      if (isMobile) {
        return `translateX(calc(${sign}100% * ${index}))`;
      } else {
        const containerWidth =
          mediasSlider.parentElement.getBoundingClientRect().width;
        const translateValue =
          index * (mediaWidthPercent + (mediaGap / containerWidth) * 100);
        return `translateX(calc(${sign}${translateValue}%))`;
      }
    }

    // Update the mediasSlider style in updateSlider()
    function updateSlider(index) {
      mediasSlider.style.transition = `transform ${TRANSITION_DURATION}ms ease-out`;
      mediasSlider.style.transform = calculateTranslateX(index);
      updateArrow(index);
    }

    // Desktop backdrop: crossfade a new layer over the old one only once the new image
    // is decoded (no blank frame), and drop stale requests when arrows are clicked quickly.
    let bgToken = 0;
    const updateBackground = (index) => {
      if (isMobile) return;

      const newMediaWrapper = productMedias[index];
      const background = document.querySelector(".product-page__background");
      if (!background || !newMediaWrapper) return;
      const token = ++bgToken;

      let layer;
      let ready;
      if (newMediaWrapper.dataset.mediaType === "video") {
        const source = newMediaWrapper.querySelector("video");
        if (!source) return;
        layer = document.createElement("div");
        layer.className = "product-page__background-video";
        const video = source.cloneNode(true);
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.removeAttribute("controls");
        layer.appendChild(video);
        ready = new Promise((resolve) => {
          if (video.readyState >= 2) return resolve();
          video.addEventListener("loadeddata", resolve, { once: true });
          setTimeout(resolve, 1500);
        });
      } else {
        const imgElement = newMediaWrapper.querySelector("img");
        if (!imgElement) return;
        const img = document.createElement("img");
        img.className = "product-page__background-img";
        img.alt = "";
        img.decoding = "async";
        img.sizes = imgElement.sizes;
        if (imgElement.srcset) img.srcset = imgElement.srcset;
        img.src = imgElement.currentSrc || imgElement.src;
        layer = img;
        ready = (img.decode ? img.decode() : Promise.resolve()).catch(() => {});
      }

      layer.classList.add("pbg-layer");
      background.appendChild(layer);

      ready.then(() => {
        if (token !== bgToken) {
          layer.remove(); // a newer slide was requested meanwhile
          return;
        }
        requestAnimationFrame(() => {
          layer.classList.add("is-in");
          const old = Array.from(background.children).filter((el) => el !== layer);
          setTimeout(() => {
            if (token === bgToken) old.forEach((el) => el.remove());
          }, 500);
        });
      });
    };

    // Update media fading during drag
    const updateMediaFadeDuringDrag = (distance) => {
      // Determine if we've exceeded threshold in either direction
      const newExceeded = Math.abs(distance) > DRAG_THRESHOLD;
      const newDirection = distance > 0 ? "right" : "left";

      // Only update if state changed
      if (newExceeded !== exceededThreshold || newDirection !== direction) {
        exceededThreshold = newExceeded;
        direction = newDirection;

        // In RTL, dragging right reveals the next item (items overflow to the left)
        const towardNext = isRtl ? direction === "right" : direction === "left";
        const towardPrev = isRtl ? direction === "left"  : direction === "right";

        if (exceededThreshold) {
          if (towardNext && currentSlideIndex < mediaLength - 1) {
            productMedias[currentSlideIndex].classList.add("fadeOut");
          } else if (towardPrev && currentSlideIndex > 0) {
            productMedias[currentSlideIndex - 1].classList.remove("fadeOut");
          }
        } else {
          if (towardNext) {
            productMedias[currentSlideIndex].classList.remove("fadeOut");
          } else if (towardPrev && currentSlideIndex > 0) {
            productMedias[currentSlideIndex - 1].classList.add("fadeOut");
          }
        }
      }
    };

    const updateMediasFading = (index) => {
      productMedias.forEach((media, i) => {
        const isBefore = i < index;
        media.classList.toggle("fadeOut", isBefore);

        if (i < index) {
          media.setAttribute("tabindex", "-1"); // Prevent focus
        } else {
          media.removeAttribute("tabindex"); // Allow focus
          const video = media.querySelector("video");
          if (video) {
            video.currentTime = 0;
            if (i > index) video.pause();
            else video.play();
          }
        }
      });
      updateActiveBullet(index);
    };

    const updateActiveBullet = (index) => {
      sliderBullets.forEach((bullet, i) => {
        bullet.classList.toggle("active", i === index);
      });
    };

    // Unified pointer down handler
    const handlePointerDown = (e) => {
      // Clicks on the arrows / bullets are not drags. Starting a drag here set
      // transition:none mid-slide, which made the image snap (skip its animation)
      // when the arrows were clicked quickly.
      if (e.target.closest(".slider-container, .slider-nav, .slider-bullet")) return;
      isDragging = true;
      startX = getClientX(e);
      currentX = startX;
      dragDistance = 0;
      exceededThreshold = false;
      direction = null;
      slider.classList.add("dragging");
      mediasSlider.style.transition = "none";
    };

    // Unified pointer move handler
    const handlePointerMove = (e) => {
      if (!isDragging) return;

      const previousX = currentX;
      currentX = getClientX(e);
      dragDistance = currentX - startX;

      // Calculate the drag offset with resistance
      const offset = dragDistance * 0.5;

      // Apply the drag offset to the slider
      const currentTransform = parseTransform(mediasSlider.style.transform);
      mediasSlider.style.transform = `translateX(calc(${currentTransform}% + ${offset}px))`;

      // Update fade state during drag
      updateMediaFadeDuringDrag(dragDistance);
    };

    // Unified pointer up handler
    const handlePointerUp = (e) => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove("dragging");

      // Restore transition
      mediasSlider.style.transition = "transform 0.5s ease-out";

      // Check if drag distance exceeds threshold
      if (Math.abs(dragDistance) > DRAG_THRESHOLD) {
        // In RTL the flex items overflow LEFT, so dragging right reveals the next item
        const goingNext = isRtl ? dragDistance > 0 : dragDistance < 0;
        const goingPrev = isRtl ? dragDistance < 0 : dragDistance > 0;
        if (goingPrev && currentSlideIndex > 0) {
          goToSlide(currentSlideIndex - 1);
        } else if (goingNext && currentSlideIndex < mediaLength - 1) {
          goToSlide(currentSlideIndex + 1);
        } else {
          // Return to current slide if at boundary
          updateSlider(currentSlideIndex);
          resetFadeState();
        }
      } else {
        // Return to current slide if threshold not met
        updateSlider(currentSlideIndex);
        resetFadeState();
      }

      // Reset drag state
      dragDistance = 0;
      exceededThreshold = false;
      direction = null;
    };

    // Reset fade state after drag ends
    const resetFadeState = () => {
      productMedias.forEach((media) => {
        const mediaIndex = parseInt(media.dataset.mediaIndex);
        if (mediaIndex < currentSlideIndex) {
          media.classList.add("fadeOut");
        } else {
          media.classList.remove("fadeOut");
        }
      });
    };

    // Helper function to parse transform value
    function parseTransform(transform) {
      if (!transform) return 0;
      const match = transform.match(/translateX\(calc\(([-\d.]+)%/);
      return match ? parseFloat(match[1]) : 0;
    }

    // Helper function to get the X position from different event types
    function getClientX(e) {
      return e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
    }

    // Unified slide navigation function
    function goToSlide(index) {
      // If already transitioning, queue this navigation
      if (isTransitioning) {
        queuedNavigation = index;
        return;
      }

      clearTimeout(timeout);
      pauseAllVideos();
      currentSlideIndex = index;

      // Set transitioning flag
      isTransitioning = true;

      updateSlider(currentSlideIndex);

      // Delay the fade effects for consistency
      timeout = setTimeout(() => {
        updateMediasFading(currentSlideIndex);
        updateActiveBullet(currentSlideIndex);

        if (!isMobile) {
          updateBackground(currentSlideIndex);
        }

        // Transition complete
        isTransitioning = false;

        // Process any queued navigation
        if (queuedNavigation !== null) {
          const nextIndex = queuedNavigation;
          queuedNavigation = null;
          goToSlide(nextIndex);
        }
      }, FADE_DELAY);
    }

    // Navigation buttons handler

    // Update the handleNavigationArrows function
    const handleNavigationArrows = (e) => {
      if (isTransitioning) return;

      if (e.target.classList.contains("prev") && currentSlideIndex > 0) {
        goToSlide(currentSlideIndex - 1);
      }

      if (
        e.target.classList.contains("next") &&
        currentSlideIndex < mediaLength - 1
      ) {
        goToSlide(currentSlideIndex + 1);
      }
    };

    // Bullet navigation handler
    sliderBullets.forEach((bullet) => {
      bullet.addEventListener("click", function () {
        const slideIndex = parseInt(this.dataset.bulletSlide);
        goToSlide(slideIndex);
      });
    });

    // Event listeners
    slider.addEventListener("pointerdown", handlePointerDown);

    document.addEventListener("pointermove", handlePointerMove);
    document.addEventListener("pointerup", handlePointerUp);
    document.addEventListener("pointercancel", handlePointerUp);

    // Prevent default for mouse events to avoid text selection
    slider.addEventListener("dragstart", (e) => e.preventDefault());

    // Navigation buttons
    if (sliderBtns) {
      sliderBtns.addEventListener("click", handleNavigationArrows);
    }

    // Update video tag in main media to autoplay
    document.querySelectorAll(".product-video").forEach((video) => {
      video.setAttribute("autoplay", "true");
      video.setAttribute("loop", "true");
      video.setAttribute("muted", "true");
      video.removeAttribute("controls");
    });

    // Initialize first slide
    updateMediasFading(0);
    updateActiveBullet(0);
  }

  // Product form handling
  const productForm = document.getElementById("product-form");
  const productQuantity = productForm.querySelector('[name="quantity"]');
  const radios = productForm.querySelectorAll(
    ".product-page input[type='radio']",
  );
  const stockError = productForm.querySelector(".stock-error--pg");

  const setSelectedBundle = (e, radio) => {
    radios.forEach((radio) => {
      radio === e.target
        ? radio.setAttribute("checked", true)
        : radio.setAttribute("checked", false);
    });
    const quantity = e.target.dataset.quantity;
    productQuantity.value = quantity;
  };

  radios.forEach((radio) => {
    if (radio) {
      radio.addEventListener("click", setSelectedBundle);
    }
  });

  // Simple 1x / 2x: display × data-qty-multiplier → cart quantity
  const inlineQtySelector = productForm?.querySelector(
    "[data-product-qty-selector]",
  );
  if (inlineQtySelector && productQuantity) {
    const qtyInput = inlineQtySelector.querySelector("[data-qty-input]");
    const qtyPlus = inlineQtySelector.querySelector("[data-qty-plus]");
    const qtyMinus = inlineQtySelector.querySelector("[data-qty-minus]");
    const mult = Math.max(
      1,
      parseInt(inlineQtySelector.dataset.qtyMultiplier, 10) || 1,
    );

    const syncCartQuantity = () => {
      let displayVal = parseInt(qtyInput.value, 10) || 1;
      displayVal = Math.max(1, displayVal);
      qtyInput.value = displayVal;
      productQuantity.value = String(displayVal * mult);
    };

    const initialCart = parseInt(productQuantity.value, 10) || mult;
    const initialDisplay = Math.max(1, Math.round(initialCart / mult));
    qtyInput.value = String(initialDisplay);
    productQuantity.value = String(initialDisplay * mult);

    qtyPlus?.addEventListener("click", () => {
      const displayVal = (parseInt(qtyInput.value, 10) || 1) + 1;
      qtyInput.value = displayVal;
      productQuantity.value = String(displayVal * mult);
    });

    qtyMinus?.addEventListener("click", () => {
      let displayVal = parseInt(qtyInput.value, 10) || 1;
      if (displayVal > 1) {
        displayVal--;
        qtyInput.value = displayVal;
        productQuantity.value = String(displayVal * mult);
      }
    });

    qtyInput?.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/\D/g, "") || "1";
      syncCartQuantity();
    });
    qtyInput?.addEventListener("blur", () => syncCartQuantity());
  }

  // Collect any checked cross-sell products (rendered by the prod_cross_sell block),
  // each with the quantity chosen in its own stepper. A row can carry two products
  // (data-cross-sell-ids="id1,id2"): both are added, at the row's quantity.
  function getCrossSellItems() {
    return Array.from(
      document.querySelectorAll("[data-cross-sell-checkbox]:checked"),
    )
      .flatMap((cb) => {
        const row = cb.closest(".cross-sell");
        const qtyInput = row && row.querySelector("[data-xsell-input]");
        let qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!Number.isFinite(qty) || qty < 1) qty = 1;
        const ids = (cb.dataset.crossSellIds || cb.value || "").split(",").map((s) => s.trim()).filter(Boolean);
        return ids.map((id) => ({ id, quantity: qty }));
      })
      .filter((it) => it.id);
  }
  // The sticky bar (card-product.js) adds these too.
  window.getPdpCrossSellItems = getCrossSellItems;

  // Free-shipping chip on each cross-sell row: shown while
  // (main product's current price) + (the row's shown price x1) >= the free-shipping
  // threshold. Main price = the selected offer card's price when the offers selector is
  // used, else the unit price (custom.discounted_price, else the selected variant) x the
  // displayed quantity. Re-checked on any form interaction and on variant changes.
  const xsellRows = Array.from(document.querySelectorAll("[data-xsell-row]"));
  const xsellMainEl = document.querySelector("script[data-xsell-main]");
  let xsellMain = null;
  try { xsellMain = xsellMainEl ? JSON.parse(xsellMainEl.textContent) : null; } catch (e) { xsellMain = null; }

  function parseMoneyCents(text) {
    if (!text) return 0;
    const latin = String(text)
      .replace(/[\u0660-\u0669]/g, (d) => String(d.charCodeAt(0) - 0x0660))
      .replace(/\u066B/g, ".")
      .replace(/[^0-9.]/g, "");
    const v = parseFloat(latin);
    return Number.isFinite(v) ? Math.round(v * 100) : 0;
  }

  function xsellMainCents() {
    const qtyVal = productQuantity ? String(productQuantity.value || "1") : "1";
    const offers = productForm.querySelector(".product-purchase");
    if (offers) {
      const radio = offers.querySelector('.subs-group-input[data-quantity="' + qtyVal + '"]');
      const priceEl = radio && radio.closest(".subs-group-fieldset")?.querySelector(".product__price");
      const cents = priceEl ? parseMoneyCents(priceEl.textContent) : 0;
      if (cents > 0) return cents;
    }
    let unit = 0;
    if (xsellMain && xsellMain.fixed) unit = xsellMain.fixed;
    else if (xsellMain && xsellMain.prices) {
      const idEl = productForm.querySelector('[name="id"]');
      unit = xsellMain.prices[idEl && idEl.value] || 0;
    }
    const disp = productForm.querySelector("[data-product-qty-selector] [data-qty-input]");
    const n = disp ? Math.max(1, parseInt(disp.value, 10) || 1) : 1;
    return unit * n;
  }

  function syncXsellShipping() {
    if (!xsellRows.length || !xsellMain || !(xsellMain.ship > 0)) return;
    const main = xsellMainCents();
    xsellRows.forEach((row) => {
      const chip = row.querySelector("[data-xsell-ship]");
      if (!chip) return;
      const add = parseInt(row.dataset.xsellCents, 10) || 0;
      chip.hidden = !(chip.hasAttribute("data-xsell-ship-force") || (main > 0 && main + add >= xsellMain.ship));
    });
    // Panel corner pill ("+ Free shipping"): on while any card qualifies.
    const anyShip = xsellRows.some((row) => { const c = row.querySelector("[data-xsell-ship]"); return c && !c.hidden; });
    document.querySelectorAll("[data-xsg-ship]").forEach((el) => { el.hidden = !anyShip; });
  }

  // Selected state on the card (CSS :has() covers it too; the class is for older browsers).
  function syncXsellRows() {
    xsellRows.forEach((row) => {
      const cb = row.querySelector("[data-cross-sell-checkbox]");
      row.classList.toggle("is-on", !!(cb && cb.checked));
      const qty = row.querySelector("[data-xsell-input]");
      if (cb && !cb.checked && qty) qty.value = "1";
    });
  }

  // Cards are multi-select. Only cards that add the same product clash
  // (e.g. "Bag Care Kit" vs "Bag Care Kit + Refresh Spray"): ticking one unticks the other.
  function xsellIds(cb) {
    return (cb.dataset.crossSellIds || cb.value || "").split(",").map((s) => s.trim()).filter(Boolean);
  }
  function xsellExclusive(e) {
    const cb = e.currentTarget;
    if (!cb.checked) return;
    const row = cb.closest("[data-xsell-row]");
    const ids = xsellIds(cb);
    xsellRows.forEach((other) => {
      if (other === row) return;
      const ocb = other.querySelector("[data-cross-sell-checkbox]");
      if (!ocb || !ocb.checked) return;
      if (xsellIds(ocb).some((id) => ids.includes(id))) ocb.checked = false;
    });
  }

  // When the ticked single cards together make up a two-product card (e.g. Bag + Refresh),
  // the cart applies that bundle's price, split per item (first product gets the lower half:
  // 151 -> 75 + 76, as the bundle discount sets it). Show those prices on the single cards
  // while both are ticked; restore the card's own price otherwise.
  const xsellPriceNumRe = /[\d٠-٩][\d٠-٩.,٫٬]*/;
  function xsellFmt(sample, cents) {
    const v = cents / 100;
    const num = Number.isInteger(v) ? String(v) : v.toFixed(2);
    return sample.replace(xsellPriceNumRe, num);
  }
  function xsellSetShown(row, cents) {
    const nowEl = row.querySelector(".cross-sell__price-now");
    if (!nowEl) return;
    if (nowEl.dataset.orig == null) {
      nowEl.dataset.orig = nowEl.textContent;
      row.dataset.xsellOrigCents = row.dataset.xsellCents;
    }
    const was = parseInt(row.dataset.xsellWas, 10) || 0;
    const base = cents == null ? parseInt(row.dataset.xsellOrigCents, 10) || 0 : cents;
    nowEl.textContent = cents == null ? nowEl.dataset.orig : xsellFmt(nowEl.dataset.orig, cents);
    row.dataset.xsellCents = String(base);
    const pct = was > 0 ? Math.round((1 - base / was) * 100) : 0;
    row.querySelectorAll(".upg__pct, .cross-sell__badge-pct").forEach((el) => {
      el.textContent = el.textContent.replace(/\d+/, String(pct));
    });
  }
  function syncXsellComboPrices() {
    const singles = new Map();
    xsellRows.forEach((r) => {
      const c = r.querySelector("[data-cross-sell-checkbox]");
      if (c && xsellIds(c).length === 1) singles.set(xsellIds(c)[0], { row: r, cb: c });
    });
    const override = new Map();
    xsellRows.forEach((r) => {
      const c = r.querySelector("[data-cross-sell-checkbox]");
      const oids = c ? xsellIds(c) : [];
      if (!r.dataset.xsellBundle || oids.length !== 2 || !oids.every((id) => singles.get(id)?.cb.checked)) return;
      const total = parseInt(r.dataset.xsellOrigCents || r.dataset.xsellCents, 10) || 0;
      const first = Math.floor(total / 200) * 100;
      override.set(oids[0], first);
      override.set(oids[1], total - first);
    });
    singles.forEach(({ row }, id) => xsellSetShown(row, override.has(id) ? override.get(id) : null));
  }

  if (xsellRows.length) {
    xsellRows.forEach((row) => {
      const cb = row.querySelector("[data-cross-sell-checkbox]");
      if (cb) {
        cb.addEventListener("change", xsellExclusive);
        cb.addEventListener("change", syncXsellRows);
        cb.addEventListener("change", syncXsellComboPrices);
      }
    });
    window.addEventListener("pageshow", () => { syncXsellRows(); syncXsellComboPrices(); });
    syncXsellRows();
    syncXsellComboPrices();
    const resyncShip = () => setTimeout(syncXsellShipping, 0);
    ["click", "input", "change"].forEach((type) => productForm.addEventListener(type, resyncShip));
    const idEl = productForm.querySelector('[name="id"]');
    if (idEl) idEl.addEventListener("change", resyncShip);
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, resyncShip);
    }
    syncXsellShipping();
  }

  // Cross-sell (upsell) quantity steppers — independent of the main product qty.
  // The buttons/input live inside the <label>, so stop clicks from toggling the checkbox.
  document.querySelectorAll("[data-cross-sell-qty]").forEach((sel) => {
    const input = sel.querySelector("[data-xsell-input]");
    const plus = sel.querySelector("[data-xsell-plus]");
    const minus = sel.querySelector("[data-xsell-minus]");
    if (!input) return;
    plus?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      input.value = String((parseInt(input.value, 10) || 1) + 1);
    });
    minus?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = String(v - 1);
    });
    input.addEventListener("click", (e) => e.stopPropagation());
    input.addEventListener("input", () => {
      input.value = input.value.replace(/\D/g, "");
    });
    input.addEventListener("blur", () => {
      let v = parseInt(input.value, 10);
      if (!Number.isFinite(v) || v < 1) v = 1;
      input.value = String(v);
    });
  });

  // ---------------------------------------------------------------------------
  // Upgrade cards (snippets/product-upgrades.liquid): single-select checkboxes. While one
  // is checked, every PDP add path (main form, Enter submit, Buy now, sticky bar) adds
  // 1x that bundle INSTEAD of this product. The block is hidden and unchecked while a
  // multi-quantity offer is selected; nothing is persisted.
  // ---------------------------------------------------------------------------
  const upgRoots = Array.from(document.querySelectorAll("[data-upg-pdp]"));
  const upgChecks = upgRoots.flatMap((root) =>
    Array.from(root.querySelectorAll(".upg__check[data-upg-variant]")),
  );

  function syncUpgradeRows() {
    upgChecks.forEach((c) => {
      const row = c.closest("[data-upg-row]");
      if (row) row.classList.toggle("is-on", c.checked);
    });
  }

  function clearUpgrades() {
    upgChecks.forEach((c) => { c.checked = false; });
    syncUpgradeRows();
  }

  function isSingleUnit() {
    return (parseInt(productQuantity && productQuantity.value, 10) || 1) <= 1;
  }

  /** The selected bundle variant id, or null (also null while a multi-qty offer is on). */
  function getSelectedUpgrade() {
    if (!isSingleUnit()) return null;
    const c = upgChecks.find((x) => x.checked);
    return c ? c.dataset.upgVariant : null;
  }

  /** The main cart line: this product, or 1x the selected bundle instead. */
  function getMainItem(variantId, quantity) {
    const bundle = getSelectedUpgrade();
    return bundle ? { id: bundle, quantity: 1 } : { id: variantId, quantity };
  }

  function syncUpgradeVisibility() {
    if (!upgRoots.length) return;
    const single = isSingleUnit();
    if (!single) clearUpgrades();
    // Multi-quantity offer selected: hide the whole block (heading + cards).
    upgRoots.forEach((root) => { root.hidden = !single; });
  }

  if (upgRoots.length) {
    upgChecks.forEach((c) => {
      c.addEventListener("change", () => {
        if (c.checked) upgChecks.forEach((o) => { if (o !== c) o.checked = false; });
        syncUpgradeRows();
      });
    });
    // Offer radios / qty steppers update the hidden quantity in their own listeners;
    // re-check after them.
    const resync = () => setTimeout(syncUpgradeVisibility, 0);
    ["click", "input", "change"].forEach((type) => productForm.addEventListener(type, resync));
    // A variant change invalidates the selection.
    const idInput = productForm.querySelector('[name="id"]');
    if (idInput) idInput.addEventListener("change", clearUpgrades);
    // Back/forward cache: never restore a checked card.
    window.addEventListener("pageshow", clearUpgrades);
    clearUpgrades();
    syncUpgradeVisibility();

    // Sticky bar (product-card quick add, handled by card-product.js): swap the variant on
    // its form for this submit only (card-product.js reads the FormData synchronously).
    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement) || !form.closest(".product-page-quick-add")) return;
        const bundle = getSelectedUpgrade();
        const id = form.querySelector('[name="id"]');
        if (!bundle || !id) return;
        const qty = form.querySelector('[name="quantity"]');
        const prev = [id.value, qty && qty.value];
        id.value = bundle;
        if (qty) qty.value = "1";
        setTimeout(() => {
          id.value = prev[0];
          if (qty) qty.value = prev[1];
        }, 0);
      },
      true,
    );
  }

  if (productForm) {
    let isFormSubmitting = false;

    productForm.addEventListener("submit", async function (e) {
      e.preventDefault();

      // Prevent form submission if a buy now button is processing
      const processingBuyNow = Array.from(
        productForm.querySelectorAll(".buy-now-btn"),
      ).some((btn) => btn.disabled && btn.innerHTML.includes("Processing"));
      if (processingBuyNow) {
        return;
      }

      // Prevent multiple simultaneous submissions
      if (isFormSubmitting) {
        return;
      }

      const formData = new FormData(productForm);
      const submitBtn = productForm.querySelector('[type="submit"]');

      if (!submitBtn) {
        return;
      }

      const originalText = submitBtn.innerHTML;
      const formType = submitBtn.dataset.formType;

      isFormSubmitting = true;
      submitBtn.disabled = true;
      submitBtn.innerHTML = "Adding";

      try {
        // Normal add to cart flow (works for all form types including BOGO)
        const cartUrl = window.routes.cart_add_url + ".js";
        const response = await fetch(cartUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              getMainItem(formData.get("id"), formData.get("quantity")),
              ...getCrossSellItems(),
            ],
          }),
        });

        const data = await response.json();

        if (response.ok) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            action: "add",
            variant: data,
            formData: Object.fromEntries(formData),
            product: productData,
          });
        } else {
          throw new Error(data.description || "Failed to add to cart");
        }
      } catch (error) {
        stockError.style.display = "block";
        setTimeout(() => {
          stockError.style.display = "none";
        }, 2000);
        console.error("Error:", error);
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "add-to-cart",
          productId: productData.id,
        });
      } finally {
        isFormSubmitting = false;
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  }

  const quickAddElement = document.querySelector(".product-page-quick-add");
  const productPage = document.querySelector(".product-page");
  const header = document.getElementById("main-header");

  if (quickAddElement && productPage) {
    // Initially hide the quick add element
    quickAddElement.style.pointerEvents = "none";
    quickAddElement.style.opacity = "0";
    quickAddElement.style.transition =
      "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)";

    // Store last scroll position
    let lastScrollY = window.scrollY;
    let ticking = false;

    // Set initial top position
    const updateTopPosition = () => {
      quickAddElement.style.top = header.classList.contains("visible")
        ? "80px"
        : "1rem";
    };
    updateTopPosition();

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const productPageRect = productPage.getBoundingClientRect();
      const productPageTop = productPageRect.top;
      const productPageBottom = productPageRect.bottom;
      const viewportHeight = window.innerHeight;

      // Calculate how much of the product page is visible
      const visibleThreshold = viewportHeight * 0.1; // 10% of viewport

      if (!ticking) {
        window.requestAnimationFrame(() => {
          // Show/hide based on product page visibility
          if (productPageBottom < visibleThreshold) {
            // Product page is leaving viewport - show quick add
            quickAddElement.style.opacity = "1";
            quickAddElement.style.pointerEvents = "auto";
            quickAddElement.style.transform = "translate(-50%, 0)";
          } else {
            // Product page is in viewport - hide quick add
            quickAddElement.style.pointerEvents = "none";
            quickAddElement.style.opacity = "0";
            quickAddElement.style.transform =
              "translate(-50%, calc(-110% - var(--header-height, 64px)))";
          }

          // Update top position based on header visibility
          updateTopPosition();

          lastScrollY = scrollY;
          ticking = false;
        });

        ticking = true;
      }
    };

    // Add scroll event listener with debouncing
    window.addEventListener("scroll", handleScroll, { passive: true });

    window.addEventListener("beforeunload", () =>
      window.removeEventListener("scroll", handleScroll),
    );

    // Also listen for header visibility changes
    const headerObserver = new MutationObserver(updateTopPosition);
    if (header) {
      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  const buyNowButtons = productForm
    ? Array.from(productForm.querySelectorAll(".buy-now-btn"))
    : [];
  let buyNowProcessing = false;

  buyNowButtons.forEach((buyNowBtn) => {
    buyNowBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (buyNowProcessing) {
        return;
      }

      const formType = buyNowBtn.dataset.formType;
      const formData = new FormData(productForm);
      const variantId = formData.get("id");
      const isBogoForm = formType === "2x (Buy 1 Get 1 Free)";
      const rawQty = parseInt(formData.get("quantity"), 10);
      const quantity = isBogoForm
        ? Number.isFinite(rawQty) && rawQty > 0
          ? rawQty
          : 2
        : Number.isFinite(rawQty) && rawQty > 0
          ? rawQty
          : 1;

      buyNowProcessing = true;
      buyNowBtn.disabled = true;
      const originalText = buyNowBtn.innerHTML;
      buyNowBtn.innerHTML = "Processing...";

      try {
        if (isBogoForm) {
          const cartResponse = await fetch(window.routes.cart_url + ".js");
          const cartData = await cartResponse.json();

          if (cartData.items && cartData.items.length > 0) {
            const updates = {};
            cartData.items.forEach((item) => {
              updates[item.key] = 0;
            });

            const clearResponse = await fetch(
              window.routes.cart_update_url + ".js",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates }),
              },
            );

            if (!clearResponse.ok) {
              throw new Error("Failed to clear cart");
            }
          }

          const cartUrl = window.routes.cart_add_url + ".js";
          const response = await fetch(cartUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                { id: variantId, quantity: parseInt(String(quantity), 10) },
                ...getCrossSellItems(),
              ],
            }),
          });

          const data = await response.json();

          if (response.ok) {
            window.location.href = "/checkout";
            return;
          }
          throw new Error(data.description || "Failed to add to cart");
        }

        const cartUrl = window.routes.cart_add_url + ".js";
        const response = await fetch(cartUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              getMainItem(variantId, parseInt(String(quantity), 10)),
              ...getCrossSellItems(),
            ],
          }),
        });

        const data = await response.json();

        if (response.ok) {
          window.location.href = "/checkout";
          return;
        }
        throw new Error(data.description || "Failed to add to cart");
      } catch (error) {
        console.error("Buy now error:", error);
        buyNowBtn.disabled = false;
        buyNowBtn.innerHTML = originalText;
        alert("An error occurred. Please try again.");
      } finally {
        buyNowProcessing = false;
      }
    });
  });
});

// ---------------------------------------------------------------------------
// Cart milestone bar on the PDP (snippets/cart-milestone.liquid, context 'pdp').
// The Liquid snippet is the single source of truth (geometry + "add N more" message):
// on a cart change we re-fetch sections/cart-milestone.liquid through the Section
// Rendering API on this product URL (so `product` + the selected variant are in scope)
// and swap in the message + track. Triggers: pubsub cartUpdate (every add / qty / remove
// path publishes), the drawer's "cart-drawer:rendered" event (tab shown again, back/forward;
// only when the cart total moved), and variant changes. Debounced, one request in flight,
// nothing while idle. N uses the UNIT price, so quantity-offer changes need no request.
// ---------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const SEL = '[data-cart-milestone="pdp"]';
  if (!document.querySelector(SEL)) return;

  const DEBOUNCE_MS = 250;
  let timer = null;
  let inflight = false;
  let again = false;

  function variantId() {
    const form = document.getElementById("product-form");
    const id = form && form.querySelector('[name="id"]');
    return id && id.value ? id.value : "";
  }

  function sectionUrl() {
    // Featured PDP on a non-product page (homepage): fetch on the product URL, not this page.
    const featured = document.querySelector(".product-page[data-pdp-url]");
    const path = featured ? featured.dataset.pdpUrl : window.location.pathname;
    const u = new URL(path, window.location.origin);
    u.searchParams.set("section_id", "cart-milestone");
    const v = variantId();
    if (v) u.searchParams.set("variant", v);
    return u.toString();
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(run, DEBOUNCE_MS);
  }

  async function run() {
    timer = null;
    if (inflight) {
      again = true;
      return;
    }
    inflight = true;
    try {
      const res = await fetch(sectionUrl(), { headers: { Accept: "text/html" }, cache: "no-store" });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), "text/html");
      const next = doc.querySelector(SEL);
      document.querySelectorAll(SEL).forEach((cur) => swap(cur, next));
    } catch (err) {
      console.warn("[cart-milestone] refresh failed", err);
    } finally {
      inflight = false;
      if (again) {
        again = false;
        schedule();
      }
    }
  }

  function copyAttrs(from, to) {
    Array.from(from.attributes).forEach((a) => {
      if (to.getAttribute(a.name) !== a.value) to.setAttribute(a.name, a.value);
    });
  }

  /** Patch in place: keeps the aria-live status node, animates the fill from its old width. */
  function swap(cur, next) {
    if (!next) {
      cur.hidden = true;
      return;
    }
    cur.hidden = false;
    copyAttrs(next, cur);
    const curBar = cur.querySelector("[data-rewards-bar]");
    const nextBar = next.querySelector("[data-rewards-bar]");
    if (curBar && nextBar) copyAttrs(nextBar, curBar);

    const curStatus = cur.querySelector("[data-rewards-status]");
    const nextStatus = next.querySelector("[data-rewards-status]");
    if (curStatus && nextStatus) {
      curStatus.className = nextStatus.className;
      if (curStatus.innerHTML !== nextStatus.innerHTML) curStatus.innerHTML = nextStatus.innerHTML;
    }

    const curWrap = cur.querySelector(".cart-rewards-bar__track-wrap");
    const nextWrap = next.querySelector(".cart-rewards-bar__track-wrap");
    if (!curWrap || !nextWrap) {
      cur.innerHTML = next.innerHTML;
      return;
    }
    const oldFill = curWrap.querySelector("[data-rewards-fill]");
    const from = oldFill ? oldFill.style.width : "";
    const wrap = document.importNode(nextWrap, true);
    const fill = wrap.querySelector("[data-rewards-fill]");
    const to = fill ? fill.style.width : "";
    if (fill && from && from !== to) fill.style.width = from;
    curWrap.replaceWith(wrap);
    if (fill && from && from !== to) {
      void fill.offsetWidth; // commit the old width so the CSS transition runs
      requestAnimationFrame(() => {
        fill.style.width = to;
      });
    }
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      // The auto gift line is excluded from the basis, so it never moves this bar.
      if (data && data.source === "free-gift-auto") return;
      schedule();
    });
    if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }

  // Drawer re-renders that did not publish (tab visible again, bfcache restore): resync
  // only when the cart total actually moved and no refresh is already pending.
  document.addEventListener("cart-drawer:rendered", (e) => {
    if (timer || inflight) return;
    const basis = e.detail && e.detail.basis;
    const cur = document.querySelector(SEL);
    if (basis == null || !cur) return;
    if (String(basis) !== cur.dataset.basis) schedule();
  });

  const idInput = document.querySelector('#product-form [name="id"]');
  if (idInput) idInput.addEventListener("change", schedule);
});
